import { render, staticRenderFns } from "./passwordPM.vue?vue&type=template&id=73811711&"
import script from "./passwordPM.vue?vue&type=script&lang=js&"
export * from "./passwordPM.vue?vue&type=script&lang=js&"
import style0 from "./passwordPM.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "passwordPM.vue"
export default component.exports